import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import React from 'react';
export const EntriModalsExtension = ModuleExtensions.modalsExtension({
  domainTakenInWixEntriModal: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('../DomainTakenInWixEntriModal')).DomainTakenInWixEntriModal
  })),
  stopConnectionModal: /*#__PURE__*/React.lazy(async () => ({
    default: (await import('../StopConnectionModal')).StopConnectionModal
  }))
}, {
  sdkName: 'domainsEntriModals',
  version: 1
});
//# sourceMappingURL=entriModalsExtension.js.map